import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationStateService {
  private unreadCountSubject = new BehaviorSubject<number>(0);
  unreadCount$ = this.unreadCountSubject.asObservable();

  setUnreadCount(count: any) {
    this.unreadCountSubject.next(count);
  }

  getUnreadCount() {
    return this.unreadCountSubject.value;
  }
}